import apiClient from "../apiClient";

export const getAllRunningsClubsAPI = async () => {
  try {
    const response = await apiClient.get("running-points/getAllClubs");
    // console.log("Response RunningsCLubs", response?.data);

    return response?.data?.data ?? [];
  } catch (error) {
    // console.log("Error al obtener runningsClubs", error);

    throw error;
  }
};

export const joinRunningClubAPI = async (id_club) => {
  try {
    const response = await apiClient.post(
      `running-points/joinClub/${id_club}/join`
    );
    return response?.data;
  } catch (error) {
    // console.log("Error en peticion a API", error);
    throw error;
  }
};

export const leaveRunningClubAPI = async (clubId) => {
  try {
    const response = await apiClient.post(
      `running-points/leaveClub/${clubId}/leave`
    );
    return response?.data;
  } catch (error) {
    // console.log("Error al salir del club api", error);

    throw error;
  }
};

export const getGalleryClubAPI = async (clubId) => {
  try {
    const response = await apiClient.get(
      `running-points/club/${clubId}/gallery`
    );
    return response?.data?.data ?? [];
  } catch (error) {
    // console.log("Error al salir del club api", error);

    throw error;
  }
};
